import { render, staticRenderFns } from "./MiddleNews.vue?vue&type=template&id=8b333ec0&scoped=true"
import script from "./MiddleNews.vue?vue&type=script&lang=js"
export * from "./MiddleNews.vue?vue&type=script&lang=js"
import style0 from "./MiddleNews.vue?vue&type=style&index=0&id=8b333ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b333ec0",
  null
  
)

export default component.exports